import { graphql, useStaticQuery } from "gatsby"


type ContentfulPDF = {
  pdfAssets: {
    edges: {
      node: {
        contentful_id: string
        node_locale: string
        file: {
          url: string
          contentType: string
          fileName: string
        }
        description: string
      }
    }[]
  }
}
export const useContentfulPDF = (pdfUrl: string) => {
  const { pdfAssets }: ContentfulPDF = useStaticQuery(
    graphql`
      query CONTENTFUL_PDF_QUERY {
        pdfAssets: allContentfulAsset(
          filter: { file: { contentType: { eq: "application/pdf" } } }
        ) {
          edges {
            node {
              node_locale
              contentful_id
              file {
                url
                contentType
                fileName
              }
            }
          }
        }
      }
    `
  )
  return pdfAssets.edges.find(
    ({ node }) =>
      node.contentful_id === pdfUrl && node.node_locale === process.env.language
  )
}
